/* eslint-disable no-undef */
const copyButton = document.querySelector(".copy-link-button");

if (copyButton) {
  copyButton.addEventListener("click", async () => {

    const linkToCopy = window.location.href;

    try {
      await navigator.clipboard.writeText(linkToCopy);
      console.log("Link copied: " + linkToCopy);

      copyButton.classList.add("copied");

      setTimeout(() => {
        copyButton.classList.remove("copied");
      }, 1000);
    } catch (err) {
      console.error("Could not copy link: ", err);
    }
  });
}
